<template>
<div>
    <pdf                 
      v-for="i in numPages"
      :key="i"
      :src="srcPDF"
      :page="i"
      style="display: block; width: 100%; border: 1px solid #000; margin-bottom: 20px;"
    >
    </pdf>
</div>
</template>

<script>
//import { PDFDocument } from "pdf-lib";
import pdf from 'vue-pdf';

export default {
  props: {
    pdfFile: {
      type: String,
    },
    id:{
        type: String,
    }
  },
  components: {
    pdf,
    
  },
  data() {
    return {
      srcPDF: "",
      numPages: 0,
    };
  },
  created(){
    this.loadAdditionalPdf();
  },
  methods: {
    async loadAdditionalPdf() {

      this.srcPDF = await pdf.createLoadingTask(this.pdfFile);
      this.srcPDF.promise.then(pdf => {
        this.numPages = pdf.numPages;
      });

      // Fetch an existing PDF document.
      /*
      const existingPdfBytes = await fetch(this.pdfFile).then((res) => res.arrayBuffer());
      const pdfDoc = await PDFDocument.load(existingPdfBytes);
      const fDataUri = await pdfDoc.saveAsBase64({ dataUri: true });
      document.getElementById(this.id).src = fDataUri;
      */
    },
  },
};
</script>